import {UserType} from "../../../Types/UserType";
import {useFormContext} from "react-hook-form";
import {useRef, useState} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import {POST} from "../../../Hooks/RequestV2";

export default function Contractors({user}: {user: UserType}): React.ReactElement {
    const form = useFormContext();

    const [myContractors, setMyContractors] = useState(user.adminContractors);
    const [otherContractors, setOtherContractors] = useState(user.adminOtherContractors);
    const [allContractors, setAllContractors] = useState([]);

    const refMyContractorsInputName = useRef(null);
    const refMyContractorsInputNumber = useRef(null);
    const refOtherContractorsInputName = useRef(null);
    const refOtherContractorsInputNumber = useRef(null);
    const refAllContractorsInputName = useRef(null);
    const refAllContractorsInputNumber = useRef(null);

    function searchContractorsInData(data: object[], nameInput: HTMLInputElement|null, numberInput: HTMLInputElement|null, setContractor: React.Dispatch<any>): void {
        const nameValue = nameInput?.value || '';
        const numberValue = numberInput?.value || '';

        const removeDiacritics = (str: string) => {
            return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        };

        const filtered = data.filter((item: any) => {
            const nameMatch = nameValue ? removeDiacritics(item.name.toLowerCase()).includes(removeDiacritics(nameValue.toLowerCase())) : false;
            const hurtIdMatch = numberValue ? String(item.hurtId).includes(numberValue) : false;

            return nameMatch || hurtIdMatch;
        });

        if (filtered.length === 0 && nameValue === '' && numberValue === ''){
            setContractor(data);
        } else {
            setContractor(filtered);
        }
    }

    function searchContractorsInDB(nameInput: HTMLInputElement|null, numberInput: HTMLInputElement|null, setContractor: React.Dispatch<any>): void {
        if (!nameInput?.value && !numberInput?.value){
            return;
        }

        POST('/trader/find/contractor', {contractor_name: nameInput?.value, contractor_number: numberInput?.value})
            .then((response) => {
                if (response.status === 200){
                    response.json().then((json) => setContractor(json));
                }
            });
    }

    return (
        <div className={'option contractors'} >
            <h1>Wybierz kontrahenta</h1>


            <Tabs>
                <TabList>
                    <Tab><button type={'button'} className={'btn'} >Moi kontrahenci</button></Tab>
                    <Tab><button type={'button'} className={'btn'} >Lista zapasowa</button></Tab>
                    <Tab><button type={'button'} className={'btn'} >Dowolny kontrahent</button></Tab>
                </TabList>

                <div className={'scrollable'} >
                    <TabPanel>
                        <div className={'search'} >
                            <h3>Filtruj</h3>

                            <input
                                name={'my-contractor-name'}
                                placeholder={'Nazwa kontrahenta'}
                                ref={refMyContractorsInputName}
                                onChange={(e) => searchContractorsInData(user.adminContractors, refMyContractorsInputName.current, refMyContractorsInputNumber.current, setMyContractors)} />
                            <input
                                name={'my-contractor-number'}
                                placeholder={'Numer kontrahenta'}
                                ref={refMyContractorsInputNumber}
                                onChange={(e) => searchContractorsInData(user.adminContractors, refMyContractorsInputName.current, refMyContractorsInputNumber.current, setMyContractors)}  />
                        </div>
                        {myContractors.length === 0 ?

                            <div className={'empty'} >Brak danych</div>

                            :
                            <>
                                {myContractors.map((contractor: any, key: number) => {
                                    return (
                                        <div key={key} >
                                            <input type={'radio'} checked={myContractors.length === 1 ? true : undefined} {...form.register('contractor')} value={contractor.id} required={true} />
                                            <span style={{color: contractor.solid > 0 ?  'red' : ''}} >[{contractor.hurtId}] {contractor.nameWithPrefixPL}</span>
                                        </div>
                                    );
                                })}
                            </>
                        }

                    </TabPanel>
                    <TabPanel>
                        {user.adminOtherContractors.length === 0 ?

                            <div className={'empty'} >Brak danych</div>

                            :
                            <>
                                <div className={'search'} >
                                    <h3>Filtruj</h3>

                                    <input
                                        name={'my-contractor-name'}
                                        placeholder={'Nazwa kontrahenta'}
                                        ref={refOtherContractorsInputName}
                                        onChange={(e) => searchContractorsInData(user.adminOtherContractors, refOtherContractorsInputName.current, refOtherContractorsInputNumber.current, setOtherContractors)} />
                                    <input
                                        name={'my-contractor-number'}
                                        placeholder={'Numer kontrahenta'}
                                        ref={refOtherContractorsInputNumber}
                                        onChange={(e) => searchContractorsInData(user.adminOtherContractors, refOtherContractorsInputName.current, refOtherContractorsInputNumber.current, setOtherContractors)}  />
                                </div>
                                {otherContractors.map((contractor: any, key: number) => {
                                    return (
                                        <div key={key} >
                                            <input type={'radio'} {...form.register('contractor')} value={contractor.id} required={true} />
                                            <span style={{color: contractor.solid > 0 ?  'red' : ''}} >[{contractor.hurtId}] {contractor.nameWithPrefixPL}</span>
                                        </div>
                                    );
                                })}
                            </>
                        }
                    </TabPanel>
                    <TabPanel>
                        <div className={'search'} >
                            <h3>Szukaj</h3>

                            <input name={'my-contractor-name'} placeholder={'Nazwa kontrahenta'} ref={refAllContractorsInputName} />
                            <input name={'my-contractor-number'} placeholder={'Numer kontrahenta'} ref={refAllContractorsInputNumber} />

                            <button className={'btn'} type={'button'} onClick={(e) =>  searchContractorsInDB(refAllContractorsInputName.current, refAllContractorsInputNumber.current, setAllContractors)}>Szukaj</button>
                        </div>
                        {allContractors.length === 0 ?

                            <div className={'empty'} >Brak danych</div>

                            :
                            <>
                                {allContractors.map((contractor: any, key: number) => {
                                    return (
                                        <div key={key} >
                                            <input type={'radio'} {...form.register('contractor')} value={contractor.id} required={true} />
                                            <span style={{color: contractor.solid > 0 ?  'red' : ''}} >[{contractor.hurtId}] {contractor.nameWithPrefixPL}</span>
                                        </div>
                                    );
                                })}
                            </>
                        }
                    </TabPanel>
                </div>
            </Tabs>
        </div>
    );
}